import ViewHeader from './ViewHeader';

export default ViewHeader;
